module.exports = __webpack_public_path__ + "static/media/ev6.55a06b2d.jpg";